export default __webpack_public_path__ + "static/media/logo.084c63a5.svg";